<app-customer-header></app-customer-header>
<div class="container track-details">
  <form [formGroup]="billingForm" class="truckdetails mt-3">
    <div class="row">
      <div class="col-md-3">
        <p class="d-flex justify-content-center align-items-center" (click)="GoTOBack()">
          <span class="material-icons">arrow_back_ios_new</span> Back
        </p>
        <div class="truck-left">
          <div class="truck-left-icon">
            <img src="assets/img/location-color.svg" />
          </div>
          <div class="truck-left-details">
            <h5>Pickup</h5>
            <p>
              <b>Place:</b>
              <!-- {{
                SearchTruckDetails?.fromLocation?.from_area_name
                  ? SearchTruckDetails?.completePickUpAddress?.formatted_address
                  : QuoteTruckDetails?.driver_route_info[0]?.fromLocation
                      ?.from_area_name
              }} -->
              {{ getPlace() }}
            </p>

            <p>
              <b>Address:</b>
              <!-- {{
                SearchTruckDetails?.fromLocation?.from_area_name
                  ? SearchTruckDetails?.fromLocation?.from_area_name
                  : QuoteTruckDetails?.driver_route_info[0]?.fromLocation
                      .from_area_name
              }}
              {{
                SearchTruckDetails?.fromLocation?.from_city_name
                  ? SearchTruckDetails?.fromLocation?.from_city_name
                  : QuoteTruckDetails?.driver_route_info[0]?.fromLocation
                      .from_city_name
              }}
              {{
                SearchTruckDetails?.fromLocation?.from_pincode
                  ? SearchTruckDetails?.fromLocation?.from_pincode
                  : QuoteTruckDetails?.driver_route_info[0]?.fromLocation
                      .from_pincode
              }} -->
              {{ getAddress() }}
            </p>
          </div>
          <mat-divider></mat-divider>

          <div class="truck-left-icon">
            <img src="assets/img/location-color.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Dropoff</h5>
            <p>
              <b>Place:</b>
              <!-- {{
                SearchTruckDetails?.toLocation?.to_area_name
                  ? SearchTruckDetails?.toLocation?.to_area_name
                  : QuoteTruckDetails?.driver_route_info[0]?.toLocation
                      ?.to_area_name
              }} -->
              {{ getDropPlace() }}
            </p>
            <p>
              <b>Address:</b>
              <!-- {{
                SearchTruckDetails?.toLocation?.to_area_name
                  ? SearchTruckDetails?.toLocation?.to_area_name
                  : QuoteTruckDetails?.driver_route_info[0]?.toLocation
                      ?.to_area_name
              }}
              {{
                SearchTruckDetails?.toLocation?.to_city_name
                  ? SearchTruckDetails?.toLocation?.to_city_name
                  : QuoteTruckDetails?.driver_route_info[0]?.toLocation
                      ?.to_city_name
              }}
              {{
                SearchTruckDetails?.toLocation?.to_pincode
                  ? SearchTruckDetails?.toLocation?.to_pincode
                  : QuoteTruckDetails?.driver_route_info[0]?.toLocation
                      ?.to_pincode
              }} -->
              {{ getDropAddress() }}
            </p>
          </div>
          <mat-divider></mat-divider>

          <div class="truck-left-icon mt-date">
            <img src="assets/img/date-color.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Date</h5>
            <p>
              {{ SearchTruckDetails?.date | date : "dd-MM-yyyy" }}
            </p>

            <p *ngIf="alternateSelectedTruck">
              {{ alternateTruckDetails?.date | date : "dd-MM-yyyy" }}
            </p>

            <p *ngIf="loadDetails == 'quoteBooked'">
              {{ QuoteTruckDetails?.pickup_date | date : "dd-MM-yyyy" }}
            </p>
          </div>
          <mat-divider></mat-divider>

          <div class="truck-left-icon mt-date">
            <img src="assets/img/weight.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Weight</h5>
            <p>
              {{ SearchTruckDetails?.truckweight?.truck_weight }}
            </p>
            <p *ngIf="loadDetails == 'quoteBooked'">
              {{ QuoteTruckDetails?.truck_type[0]?.truck_weight }}
            </p>

            <p *ngIf="alternateSelectedTruck">
              {{ alternateTruckDetails?.truck_weight }}
            </p>
          </div>
        </div>



        <div class="truck-left" *ngIf="selectedTruck">
          <div class="truck-left-details-price">
            <div class="col-sm-12 d-flex align-items-center justify-content-between flex-row">
              <span>
                <img src="{{ selectedIndexValue?.truck_image }}" class="truckImage" />
                <p>
                  {{ selectedIndexValue?.make_name }}
                </p>
                <h6>
                  {{ selectedIndexValue?.truck_category_name }}
                </h6>
              </span>
              <span class="truck-left-price">₹{{ selectedIndexValue?.price }}/-</span>
            </div>
          </div>
        </div>

        <div class="truck-left" *ngIf="alternateSelectedTruck">
          <div class="truck-left-details-price">
            <div class="col-sm-12 d-flex align-items-center justify-content-between flex-row">
              <span>
                <img src="{{ alternateTruckDetails?.truck_image }}" class="truckImage" />
                <p>{{ alternateTruckDetails?.make_name }}</p>
                <h6>
                  {{ alternateTruckDetails?.truck_category_name }}
                </h6>
              </span>
              <span class="truck-left-price">₹{{ alternateTruckDetails?.price }}/-</span>
            </div>
          </div>
        </div>
        <div class="truck-left" *ngIf="loadDetails == 'quoteBooked'">
          <div class="truck-left-details-price">
            <div class="col-sm-12 d-flex align-items-center justify-content-between flex-row">
              <span>
                <img src="{{ QuoteTruckDetails?.truck_type[0]?.truck_type_image }}" class="truckImage" />
                <p>
                  {{ QuoteTruckDetails?.truckowner_info[0]?.username }}
                </p>
                <h6>
                  {{
                  QuoteTruckDetails?.truck_category[0]?.truck_category_name
                  }}
                </h6>
              </span>
              <span class="truck-left-price">₹{{ QuoteTruckDetails?.driver_route_info[0]?.price }}/-</span>
            </div>
          </div>
        </div>

        <div class="truck-left truck-left-category" *ngIf="selecteLoadCategory">
          <div class="truck-left-icon">
            <img src="assets/img/rupee.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Load Category:</h5>
            <p>{{ loadSelectedCategory }}</p>
          </div>
          <div class="truck-left-icon">
            <img src="assets/img/meterial.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Material Type:</h5>
            <p>{{ billingForm.value.material }}</p>
          </div>
          <a (click)="GoToEditBilling()">Edit</a>
        </div>
      </div>

      <div class="col-md-9">
        <mat-accordion class="truck-details">
          <!-- truck Details list  -->
          <mat-expansion-panel *ngIf="panel" [disabled]="panel" [expanded]="panelForm" hideToggle>
            <mat-expansion-panel-header>
              <img class="width-20" src="assets/img/down.svg" *ngIf="downImg" alt="" />
              <img class="width-20" src="assets/img/checked-color.svg" *ngIf="checkImg" alt="" />
              <span class="material-icons">arrow_back_ios_new</span>
              Booking Details
            </mat-expansion-panel-header>
            <form class="bg-white">
              <div class="row">
                <div class="col-md-5">
                  <form [formGroup]="coordinatesForm">
                    <div class="input-fileds-container mt-0">
                      <div class="group mb-0 truck-details-input">
                        <div>
                          <mat-form-field
                            class="mat-block pickup_location_09 mat-icon-left flex-gt-md example-full-width" flex-gt-md>
                            <mat-icon matPrefix class="me-1 mt-2">near_me</mat-icon>
                            <input formControlName="from_area_name" #pickUpLocationSearchField matInput type="text"
                              placeholder="Pickup Area, City" />
                          </mat-form-field>
                        </div>

                        <!-- Dynamic Stops -->
                        <div formArrayName="stops" class="stops-wrapper">
                          <div class="stop-field-row" *ngFor="let stop of stopsArray.controls; let i = index"
                            [formGroupName]="i">
                            <div class="stop-input-container">
                              <!-- Stop Address Input -->
                              <mat-form-field
                                class="mat-block pickup_location_09 mat-icon-left flex-gt-md example-full-width"
                                flex-gt-md>
                                <mat-icon matPrefix class="me-1 mt-2">stop_circle</mat-icon>
                                <input matInput placeholder="Add Stop {{ i + 1 }} Area, City" type="text"
                                  formControlName="address" #stopAddress
                                  (focus)="initStopAutocomplete(stopAddress, i)" />
                              </mat-form-field>
                              <!-- Action Buttons -->
                              <div class="stop-actions">
                                <!-- Move Up -->
                                <button type="button" class="btn-icon-sm" (click)="moveStopUp(i)" [disabled]="i === 0"
                                  matTooltip="Move Up">
                                  ↑
                                </button>
                                <!-- Move Down -->
                                <button type="button" class="btn-icon-sm" (click)="moveStopDown(i)"
                                  [disabled]="i === stopsArray.length - 1" matTooltip="Move Down">
                                  ↓
                                </button>
                              </div>
                              <div class="stop-actions">
                                <button type="button" class="btn-delete-sm" (click)="removeStopField(i)"
                                  [disabled]="stopsArray.length === 1" [matTooltipDisabled]="stopsArray.length === 1"
                                  matTooltip="Remove Stop">
                                  ×
                                </button>
                                <button type="button" class="btn-delete-sm" (click)="addStopField()"
                                  matTooltip="Add New Stop">
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <mat-form-field class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                          flex-gt-sm>
                          <mat-icon matPrefix class="me-1 mt-2">location_on</mat-icon>
                          <input style="color: black; float: right" formControlName="to_area_name"
                            #dropLocationSearchField matInput type="text" placeholder="Dropup Area, City" />
                        </mat-form-field>
                        <mat-form-field class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                          flex-gt-sm>
                          <input [matDatepicker]="picker1" matInput readonly placeholder="Pickup Date" [min]="minDate"
                            [max]="maxDate" formControlName="date" />
                          <mat-datepicker-toggle matSuffix [for]="picker1">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <div>
                          <mat-form-field
                            class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width truck-type-input"
                            flex-gt-sm>
                            <mat-select dropLocationSearchField placeholder="Truck Category"
                              formControlName="truck_category_name" (selectionChange)="GetTruckWeight()" required>
                              <mat-option>Select Truck category</mat-option>
                              <mat-option *ngFor="let cat of truckCategory" value="{{ cat._id }}">
                                {{ cat.truck_category_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field
                            class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width" flex-gt-sm>
                            <mat-select dropLocationSearchField placeholder="Weight" formControlName="truck_weight"
                              required>
                              <mat-option value="">Select Weight</mat-option>
                              <mat-option *ngFor="let item of truckWeight" value="{{ item._id }}">{{
                                item.truck_weight.replace(' ', '') }} {{ item.truck_feet.replace(' ', '') }} {{
                                item.minimum_amount }}W</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-7 booking-map-container">
                  <div tabindex="0" aria-label="Map" class="map booking-map" id="map">
                    <google-map width="100%" [center]="inititalCoordinates" [options]="mapConfigurations">
                    </google-map>
                  </div>
                </div>
              </div>
            </form>
          </mat-expansion-panel>
          <!-- load details  -->
          <mat-expansion-panel [disabled]="panel" *ngIf="panel2" [expanded]="panel2form1" hideToggle>
            <mat-expansion-panel-header class="panel2Header">
              <img class="width-20" src="assets/img/down.svg" *ngIf="downImg2" alt="" />
              <img class="width-20" src="assets/img/checked-color.svg" *ngIf="checkImg2" alt="" />
              <mat-panel-title> Load Details </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row panel2 m-0 mt-4 d-none">
              <div class="col-sm-2 loadDetails d-flex align-items-center">
                <mat-label>Load Category :</mat-label>
              </div>
              <div class="col-sm-10 d-flex align-items-center load-details-btn-cntr">
                <div class="load-details load-details-btn load-categorie"
                  *ngFor="let item of loadCategory; let i = index">
                  <div [class.load-categorie-selected]="
                      i == loadCategorySelectedindex
                    ">
                    <button (click)="loadCatChange(item.load_category, i)">
                      {{ item.load_category }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row panel2 m-0 mt-4 mb-3">
              <div class="col-sm-2 loadDetails d-flex align-items-center">
                <mat-label>Material Type :</mat-label>
              </div>
              <div class="col-sm-10 d-flex align-items-center">
                <div class="load-details">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="material">
                      <mat-option value="">Select Material</mat-option>
                      <mat-option *ngFor="let item of materialDetails?.material_type" (click)="others(item)"
                        value="{{ item.name }}">
                        {{ item.name }} ({{item.hsn_code}})
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row panel2 m-0 mt-4 mb-3" *ngIf="othersType">
              <div class="col-sm-2 d-flex align-items-center">
                <mat-label>Others Material Type</mat-label>
              </div>
              <div class="col-sm-6 d-flex">
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Other Material Type" formControlName="others" />
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="panel1" [disabled]="panel2" [expanded]="panel1form1" hideToggle>
            <mat-expansion-panel-header>
              <img class="width-20" src="assets/img/down.svg" *ngIf="downImg1" alt="" />
              <img class="width-20" src="assets/img/checked-color.svg" *ngIf="checkImg1" alt="" />

              <mat-panel-title> Truck Details </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- quotation to trip -->
            <div class="truckDetails_01">
              <div class="row" [class.truck-selected-color]="i == selectedTruckDetailsIndex"
                *ngFor="let item of truck_details; let i = index" (click)="onTruckSelected(item, i)">
                <div class="col-sm-4 d-flex align-items-center justify-content-center flex-column">
                  <img class="image" src="{{ item.truck_image }}" />
                </div>
                <div class="col-sm-3 d-flex align-items-center justify-content-center flex-column">
                  <p class="m-0 color-black">
                    {{ item.truck_feet }}
                  </p>
                  <span class="center-ball"></span>
                  <p class="m-0 color-black">
                    {{ item.truck_weight }}
                  </p>
                </div>
                <div class="col-sm-5">
                  <span class="right-top-area">{{
                    item?.date | date : "fullDate"
                    }}</span>
                  <span class="truckPrice-area">
                    {{ item?.price.toFixed(2) }}
                    <span *ngIf="selectedTruck">Selected
                      <img src="assets/img/checked.svg" />
                    </span>
                  </span>
                  <span class="right-bottom-area">
                    <span class="lock-btn">
                      <img src="assets/img/lock.svg" />
                    </span>
                    Pay 10% and lock the deal
                  </span>
                </div>
                <mat-divider></mat-divider>
              </div>
            </div>

            <!-- Quotes to listing -->
            <div *ngIf="Quotation">
              <div class="row mtb d-flex align-items-center">
                <div class="col-sm-12 span m-3 d-flex align-items-center justify-content-center flex-column">
                  <span>Sorry, We couldn't find any truck with the filters you've
                    selected. Here are some regular
                  </span>
                  <span>options you may wish to explore.</span>
                </div>
                <mat-divider></mat-divider>
                <div class="row rounded-lg" [class.truck-selected-color]="
                    i == alternateSelectedTruckDetailsIndex
                  " *ngFor="let item of quote_details; let i = index" (click)="onQuoteTruckSelected(item, i)">
                  <div class="col-sm-4 d-flex align-items-center justify-content-center flex-column">
                    <img class="image" src="{{ item.truck_image }}" />
                  </div>
                  <div class="col-sm-3 d-flex align-items-center justify-content-center flex-column">
                    <p class="m-0 color-black">
                      {{ item.truck_feet }}
                    </p>
                    <span class="center-ball"></span>
                    <p class="m-0 color-black">
                      {{ item.truck_weight }}
                    </p>
                  </div>
                  <div class="col-sm-5">
                    <span class="right-top-area">{{
                      item?.date | date : "fullDate"
                      }}</span>
                    <span class="truckPrice-area">
                      {{ item?.price }}
                      <span *ngIf="alternateSelectedTruck">Selected
                        <img src="assets/img/checked.svg" />
                      </span>
                    </span>
                    <span class="right-bottom-area">
                      <span class="lock-btn">
                        <img src="assets/img/lock.svg" />
                      </span>
                      Pay 10% and lock the deal
                    </span>
                  </div>
                  <mat-divider></mat-divider>
                </div>
                <div class="col-sm-12 m-2 flex-column">
                  <a (click)="findExactTrucks()" style="
                      text-decoration: underline;
                      color: #f58634;
                      cursor: pointer;
                      font-size: 16px;
                    ">No, please find exact truck</a>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Billing and payment Details  -->
          <mat-expansion-panel class="panel3" [disabled]="panel1" [expanded]="panel3form1" *ngIf="panel3" hideToggle>
            <mat-expansion-panel-header>
              <img class="width-20" src="assets/img/down.svg" *ngIf="downImg3" alt="" />
              <img class="width-20" src="assets/img/checked-color.svg" *ngIf="checkImg3" alt="" />
              <mat-panel-title>Billing & Payment Details </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row m-0 billing-details">
              <div class="col-sm-3" *ngIf="editBilling">
                <p>Billing Details</p>
                <mat-divider class="billing-divider"></mat-divider>
                <div class="billing-info-content">
                  <div *ngIf="profileDetails?.username">{{ profileDetails?.username }}</div>
                  <div *ngIf="profileDetails?.address_line">{{ profileDetails?.address_line }}</div>
                  <div *ngIf="profileDetails?.area_name">{{ profileDetails?.area_name }}</div>
                  <div *ngIf="profileDetails?.mobile || profileDetails?.city">
                    <span *ngIf="profileDetails?.mobile">{{ profileDetails?.mobile }}</span><span *ngIf="profileDetails?.mobile && profileDetails?.city">, </span><span *ngIf="profileDetails?.city">{{ profileDetails?.city }}</span>
                  </div>
                  <div *ngIf="profileDetails?.pincode">{{ profileDetails?.pincode }}</div>
                  <div *ngIf="profileDetails?.state">{{ profileDetails?.state }}</div>
                </div>

                <mat-divider class="billing-divider"></mat-divider>
                <div class="billing-gst-line">
                  <strong>GST: {{ profileDetails?.gst || 'NA' }}</strong>
                  <img
                    *ngIf="profileDetails?.gst && (profileDetails?.gst_verified || isGstVerified)"
                    src="assets/img/tick-verify.svg"
                    class="gst-tick-icon"
                    title="Verified with Master India"
                    alt="Verified"
                  />
                  <span *ngIf="profileDetails?.gst && !profileDetails?.gst_verified && !isGstVerified" class="unverified-badge-inline">
                    (Unverified)
                  </span>
                </div>
                <div class="gst-warning" *ngIf="profileDetails?.gst && !isValidGST(profileDetails?.gst)">
                  Invalid GST number -- only <strong>FCM</strong> applicable.
                </div>
                <div class="Editbtn_billing">
                  <button (click)="BillingEdit()">Edit</button>
                </div>
              </div>

              <div class="col-sm-3" *ngIf="billingEdit">
                <p>Billing Details</p>
                <mat-divider></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Full Name" formControlName="username" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Address Line 1" formControlName="address_line" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="City" formControlName="city" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="State" formControlName="state" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Pincode" maxlength="6" minlength="6"
                    formControlName="pincode" />
                </mat-form-field>
                <div class="field-verify-wrapper">
                  <mat-form-field class="example-full-width" appearance="fill">
                    <input
                      matInput
                      placeholder="GST"
                      toUppercase
                      appAlphanumericOnly
                      maxlength="15"
                      formControlName="gst"
                      (input)="onGstChange()"
                    />
                  </mat-form-field>
                  <div class="verify-addon" *ngIf="billingForm.controls['gst'].value">
                    <div *ngIf="!isGstVerified && !isGstVerifying">
                      <a
                        *ngIf="billingForm.controls['gst'].value?.length === 15"
                        (click)="verifyGST(billingForm.controls['gst'].value)"
                        class="verify-action-link"
                        title="Verify GST with Master India"
                        >Verify</a
                      >
                    </div>
                    <div *ngIf="isGstVerifying" class="d-flex align-items-center">
                      <div class="inline-spinner"></div>
                      <span style="font-size: 11px; color: #64748b; margin-left: 5px;">Verifying...</span>
                    </div>
                    <div *ngIf="isGstVerified" class="verified-badge-inline">
                      <img src="assets/img/tick-verify.svg" style="width: 16px; height: 16px; min-width: 16px; max-width: 16px; vertical-align: middle; margin-right: 4px;" alt="Verified" />
                    </div>
                  </div>
                </div>
                <button class="save_btn" (click)="updateBillingAddress()">
                  Save
                </button>
              </div>
              <div class="col-sm-3">
                <p>Pickup Details</p>
                <mat-divider></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Pickup Name*" formControlName="pickupContact" required />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Mobile Number*" minlength="10"
                    maxlength="10" formControlName="pickupMobile" />
                  <!-- <mat-error *ngIf="billingForm.get('pickupMobile')?.hasError('pattern')">
                    Please enter exactly 10 digits
                  </mat-error> -->
                </mat-form-field>

                <!-- Stops Contact details Section -->
                <div *ngIf="QuoteTruckDetails?.stops && QuoteTruckDetails.stops.length > 0">
                  <p>Stop Contact Details</p>
                  <mat-divider></mat-divider>
                  <mat-accordion multi="false" class="stops-accordion no-shadow-expansion">
                    <mat-expansion-panel *ngFor="let stop of QuoteTruckDetails.stops; let i = index"
                      [expanded]="i === 0">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ i + 1 }}. {{ QuoteTruckDetails.stops[i].city_name }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="stop-fields">
                        <mat-form-field class="example-full-width" appearance="fill">
                          <input matInput formControlName="stop_contact_name_{{i}}" placeholder="Contact Name*"
                            required />
                        </mat-form-field>

                        <mat-form-field class="example-full-width" appearance="fill">
                          <input matInput (keypress)="validateNumber($event)" minlength="10" maxlength="10"
                            [formControlName]="'stop_contact_number_' + i" placeholder="Mobile Number*" required />
                          <!-- <mat-error *ngIf="billingForm.get('stop_contact_number_' + i)?.hasError('pattern')">
                            Please enter exactly 10 digits
                          </mat-error> -->
                        </mat-form-field>
                        <!-- Stop Category : pickup or dropoff -->
                        <div class="mt-2 mb-3">
                          <mat-radio-group [formControlName]="'stop_category_' + i" class="ms-2">
                            <mat-radio-button value="pickup" class="me-3">Pick</mat-radio-button>
                            <mat-radio-button value="dropoff" class="me-3">Drop</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <p class="mt-3 float-left">DropOff Details</p>
                <mat-divider></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Dropup Name*" formControlName="dropupContact" required />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Mobile Number*" minlength="10"
                    maxlength="10" formControlName="dropupMobile" />
                  <!-- <mat-error *ngIf="billingForm.get('dropupMobile')?.hasError('pattern')">
                    Please enter exactly 10 digits
                  </mat-error> -->
                </mat-form-field>
              </div>
              <div class="col-sm-6">
                <div layout="column">
                  <p>Price Details</p>
                  <mat-divider></mat-divider>

                  <div class="card-details-container" *ngIf="selectedTruck">
                    <div class="card-details">
                      <div class="card-details-left">Actual Price</div>
                      <div class="card-details-right">
                        ₹
                        {{ selectedTruckDetails?.price }}
                      </div>
                      <div *ngFor="let tax of paymentDetails">
                        <div class="card-details-left">
                          {{ tax.tax_name }} ({{ tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction }}
                          {{ tax.tax_type == "percent" ? "%" : "" }})
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'percent'">
                          ₹ {{ ((price * (tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction)) / 100) |
                          number:'1.2-2' }}
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'amount'">
                          ₹ {{ tax.tax_deduction }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-details-container" *ngIf="Quotation">
                    <div class="card-details">
                      <div class="card-details-left">Actual Price</div>
                      <div class="card-details-right" *ngIf="Quotation">
                        ₹ {{ alternateTruckDetails?.price }}
                      </div>

                      <div *ngFor="let tax of paymentDetails">
                        <div class="card-details-left">
                          {{ tax.tax_name }} ({{ tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction }}
                          {{ tax.tax_type == "percent" ? "%" : "" }})
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'percent'">
                          ₹ {{ ((price * (tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction)) / 100) |
                          number:'1.2-2' }}
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'amount'">
                          ₹ {{ tax.tax_deduction }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-details-container" *ngIf="loadDetails === 'quoteBooked'">
                    <div class="card-details">
                      <div class="card-details-left">Actual Price</div>

                      <div class="card-details-right">
                        ₹
                        {{ QuoteTruckDetails?.driver_route_info[0]?.price }}
                      </div>

                      <div *ngFor="let tax of paymentDetails">
                        <div class="card-details-left">
                          {{ tax.tax_name }} ({{ tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction }}
                          {{ tax.tax_type == "percent" ? "%" : "" }})
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'percent'">
                          ₹ {{ ((price * (tax.tax_deduction ? tax.tax_deduction : tax.fcm_deduction)) / 100) |
                          number:'1.2-2' }}
                        </div>
                        <div class="card-details-right" *ngIf="tax.tax_type == 'amount'">
                          ₹ {{ tax.tax_deduction }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                  <div class="card-details-container">
                    <div class="card-details card-details-total">
                      <div class="card-details-left">Total Amount</div>
                      <div class="card-details-right">₹ {{ round_amount }}</div>

                      <div class="card-details-left" style="color: #f58634">
                        Pay now
                      </div>
                      <div class="card-details-right" style="color: #f58634">
                        10%
                      </div>

                      <div class="card-details-left" style="color: #f58634">
                        Amount to be paid
                        <img class="image" (click)="cancel()" src="assets/img/error_amt.png" />
                      </div>
                      <div class="card-details-right" style="color: #f58634">
                        ₹ {{ round_payamount }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div *ngIf="terms" class="terms-area">
          <div class="amount-area">
            <mat-checkbox class="example-margin" value="true" formControlName="check1" required>
              <span>
                I agree to pay the remaining balance of ₹ {{ round_amount - round_payamount }} before the trip starts
              </span>
            </mat-checkbox>
          </div>
          <div class="amount-area">
            <mat-checkbox value="true" required formControlName="terms_and_conditions" (change)="selectedTerms($event)">
              <span class="terms-condition">
                I agree to all the
                <a (click)="getWebPages('termsAndConditions')">terms and conditions</a>
              </span>
            </mat-checkbox>
          </div>
          <div class="amount-area">
            <mat-checkbox value="true" required formControlName="insurance_acknowledgement">
              <span>
                I acknowledge that S9 does not provide insurance for goods and arranging insurance is my sole
                responsibility
              </span>
            </mat-checkbox>
          </div>
        </div>
        <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue fixed-btn"
          *ngIf="bookingDetailBtn" (click)="GoToLoadDetailsFromBooking()">
          Next
        </button>
        <button [class.spinner]="loading" [disabled]="loading || isModalOpen" type="button"
          class="button buttonBlue fixed-btn" *ngIf="TruckDetailsBtn" (click)="HandlePayments()">
          Next
        </button>
        <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue fixed-btn"
          *ngIf="QuoteDetailsBtn" (click)="HandlePayments()">
          Next
        </button>
        <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue fixed-btn"
          *ngIf="loadDetailsBtn" (click)="SearchTrucksAndShowDetails()">
          Next
        </button>
        <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue fixed-btn"
          *ngIf="paymentBtn" (click)="tripBooking()">
          Pay Now
        </button>
      </div>
    </div>
  </form>
</div>